export default "__VITE_ASSET__CJNAqkvF__"